import * as React from "react";
import * as FormUtils from '../formUtils/index';
import { UserELP } from '../../models/UserELP';
import { Button, Col, Row, Tooltip } from "reactstrap";
import { FormikProps, FormikValues } from "formik";
import { useState } from "react";
import { formatDate } from '../../utils';
//import AuthenticationContext from "../context/AuthenticationContext";
//import { useContext } from "react";


interface IProps {
    values: UserELP;
}

type LookupItem = {
    value: number;
    text: string;
}

const Situations: LookupItem[] = [{
    value: 1,
    text: 'A. Previous/Current CPSA practice permit has been obtained'
}, {
    value: 2,
    text: 'B. My undergraduate or postgraduate medical education experience is in a country where English is the first and native language (see above for approved list as per CPSA)'
}, {
    value: 3,
    text: 'C. More than 50% of my undergraduate and postgraduate medical education (including residency and clinical fellowship training) was taken in a country where English is the first and native language (see above for approved list as per CPSA)'
}, {
    value: 4,
    text: 'D. I am in independent practice in Canada or in a country where English is the first and native language (see above for list as approved by CPSA) and have already met ELP requirements before registering with your regulatory body'
}, {
    value: 5,
    text: 'E. I have obtained a previous exemption letter from the AIMG Program'
    }];

const Responses: LookupItem[] = [{
    value: 1,
    text: 'You have indicated that you have previous/current practice permit with the CPSA, please indicate your practice permit number below. Upload a copy of your CPSA practice permit.'
}, {
    value: 2,
    text: 'You have indicated you have undergraduate or postgraduate MEDICAL EDUCATION experience in a country where English is the first and native language, please indicate what country is on your medical degree. This also applies to the 50% or more option. Upload your clinical rotation schedule (with location and dates) and a copy of your medical degree or explain your situation further.'
}, {
    value: 3,
    text: 'You have indicated you have undergraduate or postgraduate MEDICAL EDUCATION experience in a country where English is the first and native language, please indicate what country is on your medical degree. This also applies to the 50% or more option. Upload your clinical rotation schedule (with location and dates) and a copy of your medical degree or explain your situation further.'
}, {
    value: 4,
    text: 'You have indicated that you are in independent practice in Canada or in a country where English is the first and native language.  Please specify where your licensure has been obtained.'
    }, {
        value: 5,
    text: 'You have indicated that you can provide a copy of a previous exemption letter from the AIMG Program.  Please upload the letter below.'
    }];



export function UserELPEditorFields(props: FormikProps<FormikValues>) {

    const values = props.values as UserELP;

    //const authCtx = useContext(AuthenticationContext);

    // const isReadOnly = values.userProfileId.length > 0;
    // const isReadOnly = true;
    const isReadOnly = false;

    let getResponse = function(x) {
        if (!isNaN(x)) {
            let item = Responses.find((item) => item.value == x);
            if (item)
                return item.text;
        }

        return "Select the box that BEST describes your situation first";
    };

    return (<React.Fragment>

        <div className="form-section">
            <h3>English Language Proficiency Exemption</h3>

            <div className="disclaimer-box card mb-3 p-3">

                <ul>
                    <li>To request a review of credentials in order to obtain an English Language Proficiency exemption letter.<br />&nbsp;</li>
                    <li>The AIMG Program may request additional documents and information. By completing this section, you authorize and give consent to the AIMG Program to disclose your provided information with the CPSA in order to make a decision related to your ELP testing exemption review request. This information is collected under Section 40(1) of the FOIP (Freedom of Information and Protection of Privacy) Act. Any questions can be sent to the AIMG Program at aimg@ucalgary.ca.<br />&nbsp;</li>
                    <li>As per the CPSA website, countries where English is a first and native language is based on the country written on your medical degree and may qualify an applicant for an ELP testing exemption: Australia, Bahamas, Bermuda, British Virgin Islands, Canada (Quebec and New Brunswick may be exceptions), Ireland, New Zealand, Singapore, South Africa, United Kingdom, United States of America, US Virgin Islands Caribbean Islands (Anguilla, Antigua and Barbuda, Barbados, Dominica, Grenada, Grenadines, Jamaica, St. Kitts & Nevis, St. Lucia, St. Vincent, Trinidad and Tobago)<br />&nbsp;</li>
                    <li>Note that requesting an ELP Exemption does not guarantee that an applicant has met the English Language Proficiency eligibility requirement. If an applicant would like a guarantee, we encourage applicants to submit an IELTS, OET or CELPIP Result as outlined on our website.<br />&nbsp;</li>
                </ul>
                <p className="ml-4 mr-4"><strong>The above only includes UNDERGRADUATE/POSTGRADUATE MEDICAL EDUCATION. It is the applicants responsibility to ensure the correct information is provided. The File Review Committee may reverse an ELP Exemption decision if it is found that inaccurate/incorrect information or documents are provided.<br />&nbsp;</strong></p>
            </div>

            <div className="card mb-3 p-3">
                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetDropdown<LookupItem>
                            fieldName="situationId"
                            title="Check the box that BEST describes your situation:"
                            dropdownProps={{
                                dataSource: Situations,
                                getId: x => x.value,
                                renderItem: x => x.text,
                                renderSelectedItem: x => x.text,
                                selectedValue: values.situationId
                            }}
                            disabled={isReadOnly}
                            required
                        />
                        
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetTextArea
                            fieldName="description"
                            title={getResponse(values.situationId)}
                            disabled={isReadOnly}
                            controlSize="large"
                            required
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                        <FormUtils.GroupSetCheckbox
                            fieldName="agree"
                            title="I Agree"
                            explanationText=""
                            disabled={isReadOnly}
                            required
                        />
                    </Col>
                </Row>

                {values.elpId > 0 && <>
                    <h4>Status: {values.elp}</h4>
                    <div className="decision-letter">{values.userLetter1}</div>
                </>}

                {/*<textarea id="txtAEChat" className="form-control "></textarea>*/}
                {/*<button id="btnAEChat" className="btn btn-default" onClick={sendChat}>Send</button>*/}

                <></>

                <hr />

                <FormUtils.GroupSetCheckbox
                    fieldName="hasAE2"
                    title="Add Another ELP"
                    explanationText=""
                />

                {values.hasAE2 && <>
                    <h3>English Language Proficiency 2</h3>
                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetDropdown<LookupItem>
                                fieldName="situationId2"
                                title="Check the box that BEST describes your situation:"
                                dropdownProps={{
                                    dataSource: Situations,
                                    getId: x => x.value,
                                    renderItem: x => x.text,
                                    renderSelectedItem: x => x.text,
                                    selectedValue: values.situationId2
                                }}
                                disabled={isReadOnly}
                                required
                            />

                        </Col>

                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetTextArea
                                fieldName="description2"
                                title={getResponse(values.situationId2)}
                                disabled={isReadOnly}
                                controlSize="large"
                                required
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                            <FormUtils.GroupSetCheckbox
                                fieldName="agree2"
                                title="I Agree"
                                explanationText=""
                                disabled={isReadOnly}
                                required
                            />
                        </Col>
                    </Row>

                    {values.elpId2 && values.elpId2 > 0 && <>
                        <h4>Status: {values.elp2}</h4>
                        <div className="decision-letter">{values.userLetter2}</div>
                    </>}

                    <hr />

                    <FormUtils.GroupSetCheckbox
                        fieldName="hasAE3"
                        title="Add Another ELP"
                        explanationText=""
                    />

                    {values.hasAE3 && <>
                        <h3>English Language Proficiency 3</h3>
                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetDropdown<LookupItem>
                                    fieldName="situationId3"
                                    title="Check the box that BEST describes your situation:"
                                    dropdownProps={{
                                        dataSource: Situations,
                                        getId: x => x.value,
                                        renderItem: x => x.text,
                                        renderSelectedItem: x => x.text,
                                        selectedValue: values.situationId3
                                    }}
                                    disabled={isReadOnly}
                                    required
                                />

                            </Col>

                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetTextArea
                                    fieldName="description3"
                                    title={getResponse(values.situationId3)}
                                    disabled={isReadOnly}
                                    controlSize="large"
                                    required
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                                <FormUtils.GroupSetCheckbox
                                    fieldName="agree3"
                                    title="I Agree"
                                    explanationText=""
                                    disabled={isReadOnly}
                                    required
                                />
                            </Col>
                        </Row>

                        {values.elpId3 && values.elpId3 > 0 && <>
                            <h4>Status: {values.elp3}</h4>
                            <div className="decision-letter">{values.userLetter3}</div>
                        </>}
                    </>}
                </>}

            </div>

            <div className="disclaimer-box for-fields mb-3 p-3">
                {/*<p className="disclaimer">Applicants are responsible for ensuring timely responses to ELP chat messages from the AIMG Program so that an ELP Exemption Request decision can be made.</p>
                <p className="disclaimer">Select ELP within the online CHAT for messages regarding your English Language Proficiency Test Exemption Request(s). Applicants are responsible for ensuring timely responses to ELP chat messages from the AIMG Program so that an English Language Proficiency Test Exemption decision can be made.</p>*/}
                <p className="disclaimer"><strong>To view the decision of your ELP Exemption request, click the &quot;Home&quot; button on your dashboard. Your ELP Decision Status and Decision Letter Instructions will be posted at the bottom of the page.</strong></p>
            </div>

        </div>

    </React.Fragment>);
}

